import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/src/modules/dashboard/FrameWorks/ISO_27001.js");
